import ShDateRangePicker from './src/main'

ShDateRangePicker.install = function (Vue) {
  Vue.component(ShDateRangePicker.name, ShDateRangePicker)
}

export default ShDateRangePicker
